export const getDefaultState = () => {
	return {
		reportForms: [],
		limitPerPage: 10,
		total: 0
	};
};

export default getDefaultState();
